import _ from 'lodash';
import rabbit from './rabbitmq';
import store from '../../store/index';


const RABBIT_EXCHANGE = 'lifemart-fridges';


function getRoutingKeyByEndPart(endPart, all=false) {
    if(all) {
        return `all${endPart}`;
    }

    if(!store.getters['app/fridgeId']) {
        return null;
    }

    return `${store.getters['app/fridgeId']}${endPart}`;
}

function getSendRoutingKey(all=false) {
    return getRoutingKeyByEndPart('-service', all);
}

function getReceiveRoutingKey(all) {
    return getRoutingKeyByEndPart('-service-answer', all);
}

function getToken() {
    return store.state.app.token || null;
}

async function send(action, additionalData, all=false) {
    const _sm = rabbit.getSocketManager();
    if(!_sm.client) {
        await rabbit.connect();
    }

    const routingKey = getSendRoutingKey(all);
    if(!routingKey) {
        return;
    }

    let data = _.extend({}, {token: getToken()}, {action}, additionalData);
    rabbit.sendToExchange(RABBIT_EXCHANGE, routingKey, data);
}

async function listen(cb, all=false) {
    const routingKey = getReceiveRoutingKey(all);
    if(!routingKey) {
        return;
    }

    rabbit.setListener(RABBIT_EXCHANGE, routingKey, cb);

    const _sm = rabbit.getSocketManager();
    if(!_sm.client) {
        await rabbit.connect();
    }
}

function clear() {
    rabbit.disconnect();

    const _sm = rabbit.getSocketManager();
    _sm.onConnect = () => null;
}


export default {
    send,
    listen,
    clear,
}
